import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";
import SwitchInput from "commons/ui/input/SwitchInput";
import Paper from "commons/ui/Paper";

import AttachmentPicker from "components/ui/AttachmentPicker";
import TwoLanguagesAdornment from "components/subComponents/TwoLanguagesAdornment";

import { PartnerFormHook } from "hooks/form/usePartnerForm";

type PropsType = {
    formPartnerHook: PartnerFormHook;
};

function PartnerForm({ formPartnerHook }: Readonly<PropsType>) {
    const { setSingleFile, formHook } = formPartnerHook;

    const { checkErrorVisibility, setValue, form } = formHook;

    return (
        <GridColumn>
            <Paper>
                <GridColumn>
                    <GridRow className={"title-margin"}>
                        <GridItem>
                            <h2>Impostazioni</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <SwitchInput
                                checked={form.enabled}
                                label={"Visibile"}
                                setValue={setValue}
                                path={"enabled"}
                                alignedToForm
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <InputText
                                label={"Link"}
                                value={form.link}
                                setValue={setValue}
                                path={"link"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow className={"title-margin"}>
                        <GridItem>
                            <h2>Logo</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <AttachmentPicker
                                buttonLabel={"Carica logo"}
                                accept={"image/*"}
                                file={form.logo}
                                setFile={(file) => setSingleFile(file, "logo")}
                                errors={checkErrorVisibility("logo")}
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow className={"title-margin"}>
                        <GridItem>
                            <h2>Testo Italiano</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <InputText
                                label={"Titolo"}
                                startAdornment={TwoLanguagesAdornment("it")}
                                value={form.text.it.title}
                                setValue={setValue}
                                path={"text.it.title"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>

                    {/* Testo Inglese — hidden
                    <GridRow className={"title-margin"}>
                        <GridItem>
                            <h2>Testo Inglese</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <InputText
                                label={"Titolo"}
                                startAdornment={TwoLanguagesAdornment("en")}
                                value={form.text.en.title}
                                setValue={setValue}
                                path={"text.en.title"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>
                    */}
                </GridColumn>
            </Paper>
        </GridColumn>
    );
}

export default PartnerForm;
